import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaUndefinedNode } from './TypedNode'
import { SchemaUndefinedModel } from './ViewModel'

export const SchemaUndefinedPlugin = createSchemaPlugin(
  'Schema.Undefined',
  SchemaUndefinedModel,
  SchemaUndefinedNode
)
